import httpClient from '~/http';
import { PrinterItem } from '../../types';

export const fetchPrinter = (id: string) => {
  return httpClient.get<PrinterItem>(`/api/v2/printers/${id}`);
};

export const updatePrinter = ({
  id,
  values,
}: {
  id: string;
  values: PrinterItem;
}) => {
  return httpClient.put(`/api/v2/printers/${id}`, values);
};
